export * from './testing/mock_backend';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
